import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageIndex } from "../../models";
import { successfulLogin } from "../../auth/authDataSlice";
import { BankGuaranteeFilter } from "./types";

type BankGuaranteePageState = {
  index: PageIndex;
  filter: BankGuaranteeFilter;
};

export const initialState: BankGuaranteePageState = {
  index: {
    itemsPerPage: 20,
    pageNumber: 0,
  },
  filter: {
    status: {
      ftValue: -1,
      ftDescr: "",
    },
  },
};

const name = "bankguarantees";

const bankguaranteesSlice = createSlice({
  name,
  initialState,
  reducers: {
    setBankGuaranteeIndex: (state, action: PayloadAction<PageIndex>) => ({
      ...state,
      index: action.payload,
    }),
    resetBankGuaranteeIdices: (state) => ({
      ...state,
      index: {
        itemsPerPage: state.index.itemsPerPage,
        pageNumber: initialState.index.pageNumber,
      },
    }),
    setFilter: (state, action: PayloadAction<BankGuaranteeFilter>) => ({
      ...state,
      filter: action.payload,
    }),
    removeFilter: (state, action: PayloadAction<keyof BankGuaranteeFilter>) => ({
      ...state,
      filter: {
        ...state.filter,
        [action.payload]: undefined,
      },
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(successfulLogin, (state) => ({
      ...state,
      index: {
        itemsPerPage: state.index.itemsPerPage,
        pageNumber: initialState.index.pageNumber,
      },
    }));
  },
});

export const {
  setBankGuaranteeIndex,
  resetBankGuaranteeIdices,
  setFilter,
  removeFilter,
} = bankguaranteesSlice.actions;

export default bankguaranteesSlice.reducer;
